import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

let baseStyles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: 50,
        paddingRight: 0
    },
    label: {
        fontSize: 22,
        marginLeft: 20,
        color: Theme.primaryTextColor,
        fontFamily: Theme.regularFont,
        marginTop: 10,
        textAlign: 'center'
    },
    icon: {
        width: 17,
        marginLeft: 10,
        marginTop: 10
    }
});

if (Device.isWeb) {
    baseStyles = {
        ...baseStyles,
        container: {
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: 50,
            paddingRight: 60
        },
        label: {
            fontSize: 22,
            marginLeft: 20,
            color: Theme.primaryTextColor,
            fontFamily: Theme.regularFont
        },
        icon: {
            width: 20,
            marginLeft: 10
        }
    };
}

export default StyleSheet.create(baseStyles);
